import { render, staticRenderFns } from "./FundSizeDetails.vue?vue&type=template&id=014fe458"
import script from "./FundSizeDetails.vue?vue&type=script&lang=js"
export * from "./FundSizeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports